// MaterialUploadForm.jsx
import { useState } from 'react';
import { FiFile, FiFileText, FiImage, FiMusic, FiPlus, FiTrash2, FiUploadCloud, FiVideo } from 'react-icons/fi';
import ProgressBar from '../../pages/Register/ProgressBar';
import Loader from '../Live/Loader';
import CourseItems from '../reusable/CourseItems';
import materialsFields from '../../config/materialsFields';

const MaterialUploadForm = ({ onSubmit, loading, progress, formDataAdd, setFormDataAdd, coursesDisabled = false }) => {
    const [materials, setMaterials] = useState([
        { title: '', description: '', file: null, preview: null }
    ]);
    const courseField = materialsFields.find((field) => field.name === 'course_id')

    const handleCourseChange = (value) => {
        setFormDataAdd(prev => ({ ...prev, course_id: parseInt(value.target.value) }));
    };

    const handleMaterialChange = (index, field, value) => {
        const updatedMaterials = [...materials];
        updatedMaterials[index][field] = value;
        setMaterials(updatedMaterials);
        setFormDataAdd((prev) => ({ ...prev, materials: updatedMaterials }))
    };

    const handleFileChange = (index, file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const updatedMaterials = [...materials];
            updatedMaterials[index] = {
                ...updatedMaterials[index],
                file: file,
                preview: e.target.result
            };
            setMaterials(updatedMaterials);
        };
        reader.readAsDataURL(file);
    };

    const addMaterialField = () => {
        setMaterials([...materials,
        { title: '', description: '', file: null, preview: null }
        ]);
    };

    const removeMaterialField = (index) => {
        if (materials.length === 1) return;
        const filtered = materials.filter((_, i) => i !== index);
        setMaterials(filtered);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append('course_id', formDataAdd.course_id);
        materials.forEach((material, index) => {
            data.append(`materials[${index}][title]`, material.title);
            data.append(`materials[${index}][description]`, material.description);
            data.append(`materials[${index}][file]`, material.file);
        });

        onSubmit(data);
    };

    const getFileIcon = (mimeType) => {
        if (mimeType.startsWith('image/')) {
            return <FiImage className="w-8 h-8 text-blue-500" />;
        }
        if (mimeType === 'application/pdf') {
            return <FiFileText className="w-8 h-8 text-red-500" />;
        }
        if (mimeType.startsWith('video/')) {
            return <FiVideo className="w-8 h-8 text-purple-500" />;
        }
        if (mimeType.startsWith('audio/')) {
            return <FiMusic className="w-8 h-8 text-green-500" />;
        }
        return <FiFile className="w-8 h-8 text-gray-500" />;
    };
    return (
        <div className="max-w-7xl mx-auto p-6 bg-white rounded-lg shadow-md">
            <form onSubmit={handleSubmit} className="space-y-6">
                <CourseItems field={courseField} formData={formDataAdd} handleChange={handleCourseChange} type={'select'} disabled={coursesDisabled} />
                <div className="space-y-4">
                    {materials.map((material, index) => (
                        <div key={index} className="border rounded-lg p-4 relative group">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="font-medium">Material {index + 1}</h3>
                                {materials.length > 1 && (
                                    <button
                                        type="button"
                                        onClick={() => removeMaterialField(index)}
                                        className="text-red-500 hover:text-red-700"
                                    >
                                        <FiTrash2 className="w-5 h-5" />
                                    </button>
                                )}
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium mb-1">
                                        Title *
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        className="w-full p-2 border rounded-md"
                                        value={material.title}
                                        onChange={(e) =>
                                            handleMaterialChange(index, 'title', e.target.value)
                                        }
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium mb-1">
                                        Description
                                    </label>
                                    <input
                                        type="text"
                                        className="w-full p-2 border rounded-md"
                                        value={material.description}
                                        onChange={(e) =>
                                            handleMaterialChange(index, 'description', e.target.value)
                                        }
                                    />
                                </div>

                                <div className="md:col-span-2">
                                    <label className="block text-sm font-medium mb-1">
                                        File Upload *
                                    </label>
                                    <label className="flex flex-col items-center justify-center 
  h-32 border-2 border-dashed rounded-lg cursor-pointer
  hover:border-blue-500 transition-colors relative">
                                        <input
                                            type="file"
                                            required
                                            className="hidden"
                                            onChange={(e) => handleFileChange(index, e.target.files[0])}
                                        />
                                        {material.preview ? (
                                            <div className="absolute inset-0 flex items-center justify-center p-2">
                                                {material.file.type.startsWith('image/') ? (
                                                    <img
                                                        src={material.preview}
                                                        alt="Preview"
                                                        className="max-h-full max-w-full object-contain rounded-lg"
                                                    />
                                                ) : (
                                                    <div className="flex flex-col items-center gap-2">
                                                        {getFileIcon(material.file.type)}
                                                        <span className="text-sm text-gray-600 text-center break-all">
                                                            {material.file.name}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="text-center space-y-2">
                                                <FiUploadCloud className="w-8 h-8 text-gray-400 mx-auto" />
                                                <p className="text-sm text-gray-500">Click to upload file</p>
                                            </div>
                                        )}
                                    </label>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex justify-between items-center">
                    <button
                        type="button"
                        onClick={addMaterialField}
                        className="flex items-center gap-2 text-blue-600 hover:text-blue-700"
                    >
                        <FiPlus className="w-5 h-5" />
                        Add Another Material
                    </button>

                    <button
                        type="submit"
                        disabled={loading}
                        className="px-6 py-2 bg-blue-600 text-white rounded-md
              hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed
              transition-colors flex items-center gap-2"
                    >
                        {loading ? <Loader /> : 'Upload All Materials'}
                    </button>
                </div>

                {progress > 0 && (
                    <ProgressBar progress={progress} className="mt-4" />
                )}
            </form>
        </div>
    );
};

export default MaterialUploadForm;